<template>
  <v-layout row wrap white>
    <v-flex sm4 pl-4>
      <v-text-field
        :mask="cnpj.length <= 11 ? '###.###.###-########' : '##.###.###/####-##'"
        v-model="cnpj"
        label="CPF/CNPJ"
      ></v-text-field>
    </v-flex>
    <v-flex xs4 ml-3>
      <v-text-field
        v-model="name"
        label="Procurar prestador de serviço"
        append-icon="search"
        @click:append="search"
        v-on:keydown.enter.prevent="search"
      />
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  data () {
    return {
      name: '',
      cnpj: ''
    }
  },
  props: {
    searchSvcProviders: Function
  },
  methods: {
    search () {
      this.$props.searchSvcProviders({ name: this.name, cnpj: this.cnpj })
    }
  }
}
</script>

<style>
</style>
